function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="28" height="32" viewBox="0 0 28 32" {...props}><path d="M29 32H3a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1h3v-4C6 4.477 10.477 0 16 0s10 4.477 10 10v4h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1zM22 9.5C22 6.462 19.313 4 16 4s-6 2.462-6 5.5V14h12V9.5z" /></svg>;
});